<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path d="M12.8801 17.8801H11.1201V9.52012H12.8801V17.8801Z" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.12012 12.0001C2.12012 6.54339 6.54339 2.12012 12.0001 2.12012C17.4568 2.12012 21.8801 6.54339 21.8801 12.0001C21.8801 17.4568 17.4568 21.8801 12.0001 21.8801C6.54339 21.8801 2.12012 17.4568 2.12012 12.0001ZM20.1201 12.0001C20.1201 7.52284 16.4774 3.88012 12.0001 3.88012C7.52284 3.88012 3.88012 7.52284 3.88012 12.0001C3.88012 16.4774 7.52284 20.1201 12.0001 20.1201C16.4774 20.1201 20.1201 16.4774 20.1201 12.0001Z"
    />
    <path d="M12.8801 8.3999H11.1201V6.6399H12.8801V8.3999Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconInfo',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
